import { render, staticRenderFns } from "./definir-prazo-multa.vue?vue&type=template&id=7acc1a5f&scoped=true&"
import script from "./definir-prazo-multa.vue?vue&type=script&lang=js&"
export * from "./definir-prazo-multa.vue?vue&type=script&lang=js&"
import style0 from "./definir-prazo-multa.vue?vue&type=style&index=0&id=7acc1a5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acc1a5f",
  null
  
)

export default component.exports